import React from 'react';
import styled from 'styled-components';

export default styled(({ align, children, ...rest }) => children && <div {...rest} children={children} />)`
  margin: 1rem 0;
  text-align: ${({ align }) => (align ? align : 'center')};
  color: #dc3545;
  font-size: 0.8rem;
`;
